import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4 2.5A1.5 1.5 0 0 0 2.5 4v5A1.5 1.5 0 0 0 4 10.5h5A1.5 1.5 0 0 0 10.5 9V4A1.5 1.5 0 0 0 9 2.5zM9 4H4v5h5zM15 2.5A1.5 1.5 0 0 0 13.5 4v5a1.5 1.5 0 0 0 1.5 1.5h5A1.5 1.5 0 0 0 21.5 9V4A1.5 1.5 0 0 0 20 2.5zM20 4h-5v5h5zM13.5 15a1.5 1.5 0 0 1 1.5-1.5h5a1.5 1.5 0 0 1 1.5 1.5v5a1.5 1.5 0 0 1-1.5 1.5h-5a1.5 1.5 0 0 1-1.5-1.5zm6.5 0v5h-5v-5zM4 13.5A1.5 1.5 0 0 0 2.5 15v5A1.5 1.5 0 0 0 4 21.5h5a1.5 1.5 0 0 0 1.5-1.5v-5A1.5 1.5 0 0 0 9 13.5zM9 15H4v5h5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }